<script lang="ts" setup>
const { data, status, listRef, resetData } = await useWishesFeed();
</script>

<template>
  <div
    class="max-w-section flex flex-col gap-10 z-1 relative md:gap-14 lg:gap-16"
  >
    <AppSectionHeaderWrapper>
      <AppSectionTitle
        data-aos="fade-up"
        data-aos-delay="500"
        data-aos-anchor="#wishes"
      >
        UCAPAN & DOA
      </AppSectionTitle>

      <NuxtImg
        src="/line-primary.svg"
        alt="Line Primary"
        data-aos="zoom-in"
        data-aos-delay="600"
        data-aos-anchor="#wishes"
        class="w-line-graphic"
        loading="lazy"
        decoding="async"
      />
    </AppSectionHeaderWrapper>

    <p
      class="text-center text-sm xs:text-base xl:text-lg"
      data-aos="fade"
      data-aos-delay="750"
      data-aos-anchor="#wishes"
    >
      Silahkan tinggalkan ucapan & doa terbaik untuk kami
    </p>

    <div
      class="relative w-full mx-auto max-w-screen-sm flex flex-col gap-10 md:gap-14 lg:gap-16"
    >
      <PWishesForm
        class="w-full"
        data-aos="fade-up"
        data-aos-delay="800"
        data-aos-anchor="#wishes"
        @refresh="resetData"
      />

      <ClientOnly>
        <div
          ref="listRef"
          class="max-h-[528px] overflow-y-auto px-4 md:px-6 flex flex-col gap-4 scrollable"
          data-aos-anchor="#wishes"
          data-aos="fade-up"
          data-aos-delay="900"
        >
          <ul
            v-if="data.length"
            class="flex flex-col gap-4"
          >
            <li
              v-for="message in data"
              :key="message.personal_message_id"
              class="flex flex-col gap-4"
            >
              <div class="flex flex-col gap-2">
                <div class="flex flex-wrap items-center gap-2">
                  <h6
                    class="text-primary-800 text-base md:text-lg lg:text-xl"
                  >
                    {{ message.guest_name.replace("& Sendiri", '') }}
                  </h6>

                  <UiWishesStatusIcon :status="message.status" />
                </div>
                <p
                  class="text-sm md:text-base"
                >
                  {{ message.message }}
                </p>
              </div>
              <USeparator
                color="primary"
                type="dashed"
              />
            </li>
          </ul>

          <ul
            v-if="status === 'pending'"
            class="flex flex-col gap-4"
          >
            <PWishesSkeleton
              v-for="n in 10"
              :key="n"
            />
          </ul>

          <UAlert
            v-if="!data.length && status !== 'pending'"
            title="Belum ada ucapan & doa"
            variant="subtle"
            description="Ayo jadi yang pertama memberikan ucapan & doa untuk kami!"
            class="text-center"
          />
        </div>

        <template #fallback>
          <PWishesFallback />
        </template>
      </ClientOnly>
    </div>
  </div>
</template>
